import React from 'react';
import { Box, Text } from '@wix/design-system';
import { Trans } from 'react-i18next';
import { BannerButton } from './BannerButton';
import { RootStore, withInjectedRootStore } from 'providers';

interface EditorXBannerProps {
  rootStore: RootStore;
}

export const EditorXBannerComp: React.FC<EditorXBannerProps> = ({
  rootStore,
}) => {
  const { isMobile } = rootStore.appStore;
  const bannerKey = 'editor_x_studio.banner.text';

  return (
    <Box
      width='100wh'
      padding={isMobile ? '9px 18px' : '12px 0'}
      align='center'
      gap='SP2'
      background='linear-gradient(180deg, #e9f0f9 0%, #c9d7fd 64.58%, #b2c5ff 100%)'
    >
      <Text>
        <Trans i18nKey={bannerKey} components={[<Text weight='bold' />]} />
        <Box inline marginLeft={isMobile ? 'SP1' : 'SP2'}>
          <BannerButton />
        </Box>
      </Text>
    </Box>
  );
};

export const EditorXBanner = withInjectedRootStore(EditorXBannerComp);
